import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useToast } from './ui/use-toast';
import { Logo } from './Logo';

export const Navigation = () => {
  const { toast } = useToast();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleComingSoon = (feature) => {
    toast({
      title: "🚀 Fonctionnalité en cours de développement",
      description: `${feature} sera bientôt disponible ! Restez connectés.`,
      duration: 4000,
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Accueil', href: '#home' },
    { label: 'Services', href: '#services' },
    { label: 'Application', href: '#app' },
    { label: 'Tarifs', href: '#pricing' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background/95 backdrop-blur-md shadow-elegant'
          : 'bg-transparent'
      }`}
    >
      <div className="container">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#home" className="flex items-center space-x-3 group">
            <div className="transform group-hover:scale-105 transition-transform duration-300">
              <Logo className="w-20 h-20" />
            </div>
            <div className="flex flex-col">
              <span className={`text-xl font-display font-bold leading-none transition-colors ${
                isScrolled ? 'text-foreground' : 'text-white'
              }`}>
                Open <span className="text-primary">Syne</span>
              </span>
              <span className={`text-xs transition-colors ${
                isScrolled ? 'text-muted-foreground' : 'text-white/80'
              }`}>
                E-commerce Solutions
              </span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors duration-300 relative group ${
                  isScrolled
                    ? 'text-foreground hover:text-primary'
                    : 'text-white hover:text-primary'
                }`}
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-300"></span>
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Button
              variant="outline"
              size="sm"
              className="border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground"
              onClick={() => handleComingSoon("La connexion")}
            >
              Se connecter
            </Button>
            <Button
              size="sm"
              className="bg-primary text-primary-foreground hover:bg-primary-glow shadow-glow"
              onClick={() => window.open('https://dev.vendeur.syneopen.com/#/apply', '_blank')}
            >
              Démarrer
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 transition-colors ${
              isScrolled
                ? 'text-foreground hover:text-primary'
                : 'text-white hover:text-primary'
            }`}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-background border-t border-border animate-slide-in">
          <div className="container py-4 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-2 text-foreground hover:text-primary transition-colors"
              >
                {link.label}
              </a>
            ))}
            <div className="space-y-2 pt-4 border-t border-border">
              <Button
                variant="outline"
                className="w-full border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground"
                onClick={() => handleComingSoon("La connexion")}
              >
                Se connecter
              </Button>
              <Button
                className="w-full bg-primary text-primary-foreground hover:bg-primary-glow"
                onClick={() => window.open('https://dev.vendeur.syneopen.com/#/apply', '_blank')}
              >
                Démarrer
              </Button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};